import React from "react";
import { routes } from "consts";
import { useNavigate } from "react-router-dom";
import { useToaster } from "utils";
import { HeaderWithBreadcrumbs } from "components/molecules/HeaderWithBreadcrumbs/HeaderWithBreadbrumbs";
import { PageMain } from "components/molecules";
import { PaziaBox } from "components/atoms";
import { coursegroupAttributesApi } from "api/coursegroup-attributes";
import { CourseGroupAttributeForm, CourseGroupAttributeFormValues } from "./CourseGroupAttributeForm";

export const CourseGroupAttributeAddPage = () => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useToaster();

  const onSubmit = async (data: CourseGroupAttributeFormValues) => {
    try {
      const resp = await coursegroupAttributesApi.create({
        name: data.name,
        attributeType: data.attributeType,
        options: data.options?.map((o) => ({
          value: o.value,
          numericValue: o.numericValue ?? null,
          sortOrder: o.sortOrder,
          color: o.color || null,
        })),
      });
      showSuccess(`Utworzono atrybut "${data.name}"`);
      navigate(routes.COURSE_GROUPS_ATTRIBUTES_EDIT(resp.data.id.toString()));
    } catch {
      showError("Nie udało się utworzyć atrybutu");
    }
  };

  return (
    <PageMain>
      <HeaderWithBreadcrumbs
        breadcrumbs={[
          { title: "Grupy kursów", path: routes.COURSE_GROUPS },
          { title: "Atrybuty", path: routes.COURSE_GROUPS_ATTRIBUTES },
          { title: "Dodaj atrybut" },
        ]}
        headerText="Dodaj nowy atrybut"
      />
      <PaziaBox>
        <CourseGroupAttributeForm onSubmit={onSubmit} />
      </PaziaBox>
    </PageMain>
  );
};
